import { useEffect } from "react";

export function useClickOutsideMany(guards = []) {
  useEffect(() => {
    const onDown = (e) => {
      for (const g of guards) {
        if (!g?.enabled) continue;

        const inAny = (g.refs || []).some((r) => r?.current?.contains(e.target));
        if (!inAny) g.onOutside?.();
      }
    };

    document.addEventListener("mousedown", onDown);
    return () => document.removeEventListener("mousedown", onDown);
  }, [guards]);
}